import { createSlice } from '@reduxjs/toolkit';
import { addComment, getComments } from './commentsActions';

const initialState = {
  loading: false,
  comments: null,
  error: null,
  success: false,
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    clearComments: state => {
      state.loading = false;
      state.comments = null;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: {
    // get comments
    [getComments.pending]: state => {
      state.loading = true;
    },
    [getComments.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.comments = payload.data;
    },
    [getComments.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // add comment
    [addComment.pending]: state => {
      // state.loading = true;
    },
    [addComment.fulfilled]: (state, { payload }) => {
      // state.loading = false;
    },
    [addComment.rejected]: (state, { payload }) => {
      // state.loading = false;
      state.error = payload;
    },
  },
});

export const { clearComments } = commentsSlice.actions;
export default commentsSlice.reducer;
